<template>
  <div style="height: 100%; text-align: center;">
    <v-list-subheader
      v-if="!claim?.DSSClaimsID"
      class="justify-center"
    >
      Click again Lab Conversation....!
    </v-list-subheader>

    <Messenger
      v-else
      :convo="claim?.convo"
      :system_object="claim"
    />
  </div>
</template>

<script>
import Messenger from "@/components/Messenger/Messenger.vue";
import { mapGetters } from "vuex";
export default {
  name: "LabConversation",
  components: { Messenger },

  computed: {
    ...mapGetters("osclaims", ["claim"]),
  },
  mounted() {
    console.log("claim at mount:", this.claim);
  },
};
</script>
